import styled from 'styled-components'

const SettingsContainerUi = styled.div`
  height: 100%;
`

export default SettingsContainerUi
